import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "22",
  fill: "none",
  viewBox: "0 0 22 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#667085",
      d: "M8.274 1v1.818h5.454V1h1.819v1.818h3.636a.91.91 0 0 1 .909.91v14.545a.91.91 0 0 1-.91.909H2.82a.91.91 0 0 1-.909-.91V3.728a.91.91 0 0 1 .91-.909h3.636V1zm10 9.09H3.728v7.274h14.546zm-8.182 1.82v3.636H5.547v-3.637zM6.456 4.635H3.728v3.637h14.546V4.636h-2.728v1.819h-1.818V4.636H8.274v1.819H6.456z"
    }, null, -1)
  ]))]))
}
export default { render: render }